import { useEffect, useState } from "react"
import { NavLink } from "react-router-dom"
import useLogos from "../../hooks/useLogos"
import { getInfoTextService } from "../../services/infoTextService"
import '../../styles/header.css'
import '../../styles/index.css'
import HeaderMenu from "./HeaderMenu"
import { AlertClose, AlertIcon } from "../../assets/icons/Icons"
import SpinnerCuadrado from "../../modules/helpers/SpinnerCuadrado"

const Header = () => {

    const { logoVivetuseguro } = useLogos()

    const [infoApi, setInfoApi] = useState()
    const [showAlert, setShowAlert] = useState(true);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        getInfoTextService().then((resp) => {
            setInfoApi(resp.InfoApi)
            setLoading(false);
        }).catch((err) =>{
            setLoading(false);
            console.log("Error al comunicarse con la API")
            console.log(err)
        })
    }, [])

    return (
        <>
            {loading && <SpinnerCuadrado />}
            <div className="sticky-top d-lg-block d-none">
                <div className="container-fluid header">
                    <div className="home__header">
                        <div className="home__logo">
                            <NavLink to={'/'}>
                                {logoVivetuseguro}
                            </NavLink>
                        </div>
                        <HeaderMenu infoApi={infoApi} />
                    </div>
                </div>
            </div>

            <div className="container-fluid header d-block d-lg-none">
                <div className="home__header">
                    <div className="home__logo">
                        <NavLink to={'/'}>
                            {logoVivetuseguro}
                        </NavLink>
                    </div>
                    <HeaderMenu infoApi={infoApi} />
                </div>
            </div>
            <div className="alert__wrapper">
                <div className={showAlert ? 'alert' : 'alert alert__closer'} >
                    <div className="alert__icon">
                        <AlertIcon />
                    </div>
                    <p className="alert__text">Para mejorar tu experiencia de navegación, por favor asegúrate de desbloquear las ventanas emergentes.</p>
                    <div className="alert__close" onClick={() => {setShowAlert(false)}}>
                        <AlertClose />
                    </div>
                </div>
            </div>
        </>
    )
}

export default Header